<div class="button-row" *transloco="let t; read: 'ajs'">
  <bulb-menu-list-panel [menuItems]="optionsMenuItems">
    <ng-template #buttonTemplate>
      <button #toggleEl class="ghost-button">
        <svg-icon key="ellipsis-h" fontSize="2.5em" class="menu-list-button">
        </svg-icon>
      </button>
    </ng-template>
  </bulb-menu-list-panel>

  <bulb-share-button [compositeUnit]="true" [unitId]="unitId" *ngIf="showShareMenu" [showSharePanel]=true>
    <ng-template #toggleButton>
      <aero-button
        #toggleElRef
        [label]="t('button_share')"
        svgIconKey="paper-plane"
        [aeroStyle]="buttonStyle"
      ></aero-button>
    </ng-template>
  </bulb-share-button>

  <bulb-menu-list-panel [menuItems]="createMenuItems" *ngIf="showCreateMenu">
    <ng-template #buttonTemplate>
      <span *ngIf="showDotOnCreate" class="bulb-onboarding-badge bulb-onboarding-badge-pulsate bulb-onboarding-badge-header"></span>
      <aero-button
        #toggleEl
        [aeroStyle]="buttonStyle"
        svgIconKey="sparkles"
        class="create-button"
        [label]="t('create_header')"
      ></aero-button>
    </ng-template>
  </bulb-menu-list-panel>

  <aero-button
    *ngIf="showSharePortfolioButton"
    (click)="commands.showSharePortfolioModal()"
    class="share-portfolio"
    [label]="t('account_portfolio_link')"
    svgIconKey="paper-plane"
    [aeroStyle]="buttonStyle"
  ></aero-button>

  <aero-button
    *ngIf="showCreateGroupCollectionButton"
    (click)="createGroupCollection()"
    class="share-portfolio"
    [label]="t('create_group_collection')"
    svgIconKey="collection"
    [aeroStyle]="buttonStyle"
  ></aero-button>

  <aero-button
    *ngIf="showResumeShareButton"
    (click)="commands.showShareResumeModal()"
    [label]="t('resume_share_link')"
    svgIconKey="paper-plane"
    [aeroStyle]="buttonStyle"
  ></aero-button>

  <bulb-submit-assignment-button
    styleClass="collection-submit"
    *ngIf="this.compositeUnit?.assignment && showSubmitButton"
    [unit]="this.compositeUnit"
    [buttonSize]="buttonSize">
  </bulb-submit-assignment-button>

  <bulb-menu-list-panel [menuItems]="copyCollectionItems" *ngIf="showCopyCollectionButton">
    <ng-template #buttonTemplate>
      <aero-button
        [aeroStyle]="buttonStyle"
        class="copy-collection"
        [label]="t('button_template')"
      ></aero-button>
    </ng-template>
  </bulb-menu-list-panel>
</div>
